export enum CurrentPreviousDataSwitcherEnum {
  CURRENT = 'CURRENT',
  PREVIOUS = 'PREVIOUS',
}
